import { computed } from 'vue';
import { useConvoStore } from 'src/stores/conversations';
import { useAccountStore } from 'src/stores/account';
import { stringParser } from 'src/plugins/string/string';
/**
 * Plugin containing misc methods for Chat component
 */
const ChatMiscDataPlugin = () => {
    const accountStore = useAccountStore();
    const convoStore = useConvoStore();
    const messagewidth = '7';
    const user = computed(() => accountStore.user);
    const convo = computed(() => convoStore.currentConvo);
    const liveConvo = computed(() => convoStore.all);
    const appType = computed(() => {
        const chatIdSplit = convo.value.id.split(/-72x4-|-72x3-/);
        if (chatIdSplit.length === 3) {
            return 'getspaces';
        }
        return 'spaces_ad';
    });
    const isChatUser = computed(() => {
        if (!user.value)
            return '';
        const startReg = new RegExp(`^${user.value.user_pk}[-]`);
        const isHost = startReg.test(convo.value.id);
        if (isHost)
            return '';
        const hostId = convo.value.id.split('-')[0];
        return stringParser(hostId, convo.value.receiver_name);
    });
    const receiver = computed(() => {
        if (!user.value)
            return '0';
        const dataSplit = convo.value.id.split(/-72x4-|-72x3-|-30x1-|-30x2-/);
        const userID1 = dataSplit[0];
        const userID2 = dataSplit[1];
        return Number(userID1) === Number(user.value.user_pk)
            ? userID2
            : userID1;
    });
    /**
     * Get chat background color depending on if msg is from
     * sender or receiver
     * @param value chat msg
     */
    function chatBg(value) {
        return (Number(value.sender) === (user.value.user_pk || ''))
            ? 'blue-2'
            : 'teal-2';
    }
    /**
     * Get chat text color depending on if msg is from
     * sender or receiver
     * @param value chat msg
     */
    function chatTxt(value) {
        return (Number(value.sender) === (user.value.user_pk || ''))
            ? 'grey-9'
            : 'grey-9';
    }
    /**
     * Check if user is the sender of a message
     * @param value
     * @returns
     */
    function isSender(value) {
        return Number(value.sender) === (user.value.user_pk || '');
    }
    return {
        messagewidth,
        user,
        convo,
        liveConvo,
        appType,
        isChatUser,
        receiver,
        chatBg,
        chatTxt,
        isSender
    };
};
export { ChatMiscDataPlugin };
